const CountryAddressData = [
  [
    {
      branch: "Europe",
      country: "UK",
      companyname: "Ampstek Services Limited",
      address: "124 City Road, London, England, EC1V 2NX",
      phone: "44 1339 891247",
      contact: "contact@ampstekpay.com"
    },
    {
      branch: "Europe",
      country: "Germany",
      companyname: "Ampstek Germany Gmbh",
      address: "Bethmannstr.8/ Berlinestr.51, 60311 Frankfurt am Main Deutschland Germany",
      phone: "",
      contact: "contact@ampstekpay.com"
    },
    {
      branch: "Europe",
      country: "France",
      companyname: "Ampstek France SAS",
      address: "250 B, BD Saint Germain 75007, Paris",
      phone: "",
      contact: "contact@ampstekpay.com"
    },
    {
      branch: "Europe",
      country: "Netherlands",
      companyname: "Ampstek Netherlands B.V",
      address: "Zekeringstraat 17A,1014BM Amsterdam",
      phone: "",
      contact: "contact@ampstekpay.com"
    },
    {
      branch: "Europe",
      country: "Belgium",
      companyname: "Ampstek Belgium SRL",
      address: "Boulevard Saint-Michel 65/6 - 1040 Brussels - Belgium",
      phone: "",
      contact: "contact@ampstekpay.com"
    },
    {
      branch: "Europe",
      country: "Sweden",
      companyname: "Ampstek Sweden AB",
      address: "Kungsbro Strand 29, 112 26 Stockholm",
      phone: "",
      contact: "contact@ampstekpay.com"
    },
    
    {
      branch: "Europe",
      country: "Poland",
      companyname: "Ampstek Poland Sp.Z.o.o",
      address: "ul. Solec 81B lok. A51, 00-382 , Warsaw, Poland",
      phone: "48 22 1857586",
      contact: "contact@ampstekpay.com"
    },
    {
      branch: "Europe",
      country: "Hungary",
      companyname: "Ampstek Hungary KFT",
      address: "1133 Budapest, Ipoly utca 20. üzlet 1.",
      phone: "",
      contact: "contact@ampstekpay.com"
    },
    {
      branch: "Europe",
      country: "Switzerland",
      companyname: "Ampstek Switzerland GmbH",
      address: "Bahnhofplatz 6300 Zug, Switzerland",
      phone: "",
      contact: "contact@ampstekpay.com"
    },
    {
      branch: "Europe",
      country: "Greece",
      companyname: "Ampstek Greece IT Services LTD",
      address: "196, L Syngrou, Kalithea, 17671, GREECE",
      phone: "",
      contact: "contact@ampstekpay.com"
    },
    {
      branch: "Europe",
      country: "Malta",
      companyname: "Ampstek Malta Ltd",
      address: "Exchange Buildings, Republic Street Valletta, VLT 1117, Malta",
      phone: "",
      contact: "contact@ampstekpay.com"
    },
    {
      branch: "Europe",
      country: "Serbia",
      companyname: "Ampstek IT  Services Doo",
      address: "Mirijevski Bulevar 54  Belgrade, 11000, Serbia",
      phone: "",
      contact: "contact@ampstekpay.com"
    },
    {
      branch: "Europe",
      country: "Bulgaria",
      companyname: "Ampstek Bulgaria Eood",
      address: "Rayko Daskalov St. 68, Floor 2, Office 8, 4000, Plovdiv, Bulgaria",
      phone: "",
      contact: "contact@ampstekpay.com"
    },
    {
      branch: "Europe",
      country: "Croatia",
      companyname: "Ampstek Technologies d.o.o Za Usluge",
      address: "Hrusevecka Street 3, 10000 Zagreb, Croatia",
      phone: "",
      contact: "contact@ampstekpay.com"
    },
    {
      branch: "Europe",
      country: "Czech Republic",
      companyname: "Ampstek IT Services Sro",
      address: "Zizkova 236/11, 470 01 Ceska Lipa",
      phone: "",
      contact: "contact@ampstekpay.com"
    },
    {
      branch: "Europe",
      country: "Denmark",
      companyname: "Ampstek Denmark ApS",
      address: "Advokatfirmaet Levin Skomagergade 8, 1. th., 4000 Roskilde Etterbeek",
      phone: "",
      contact: "contact@ampstekpay.com"
    },
    
    
    
    {
      branch: "Europe",
      country: "Ireland",
      companyname: "Ampstek Ireland Limited",
      address: "The Black Church, Saint Mary's Place, D07 P4AX, Dublin, Ireland",
      phone: "",
      contact: "contact@ampstekpay.com"
    },
    
    {
      branch: "Europe",
      country: "Portugal",
      companyname: "Ampstek Portugal LDA",
      address: "Rua Joaquih Antonio de Aguiar No 43 RC Esq 1070 -150 Lisboa, Portugal.",
      phone: "",
      contact: "contact@ampstekpay.com"
    },
    {
      branch: "Europe",
      country: "Romania",
      companyname: "Ampstek Services SRL",
      address: "Bucharest Sectorul 3, B-dul UNIRII,61, Bloc F3, Scara 4, Etaj 2, Apartment 208, Cod Postal 30828",
      phone: "40 609 785 3232",
      contact: "contact@ampstekpay.com"
    },
    {
      branch: "Europe",
      country: "Slovakia",
      companyname: "Ampstek SR S.R.O",
      address: "Karpatská 18, 811 05 Bratislava – Old Town Slovakia",
      phone: "",
      contact: "contact@ampstekpay.com"
    },
    {
      branch: "Europe",
      country: "Spain",
      companyname: "Ampstek Spain S.L",
      address: "AV Josep Tarradellas 38, Barcelona, Barcelona- 08029 Spain",
      phone: "",
      contact: "contact@ampstekpay.com"
    },
    
   
    
    {
      branch: "Americas",
      country: "USA",
      companyname: "Ampstek LLC",
      address: "103 Carnegie Center Drive Suite 300 Princeton-08540 USA",
      phone: "609-785-3232",
      contact: "contact@ampstekpay.com"
    },
    {
      branch: "Americas",
      country: "Canada",
      companyname: "Ampstek IT Services Inc",
      address: "37 Kollar Drive Toronto-M1G 1E4 Canada",
      phone: "609-785-3232",
      contact: "contact@ampstekpay.com"
    },
    
    {
      branch: "Americas",
      country: "Costa Rica",
      companyname: "Ampstek Costarica SRL",
      address: "800 metros sur del cruce barrio la abundancia San Carlos Alajuela-20101 Costa Rica",
      phone: "506 41021794",
      contact: "contact@ampstekpay.com"
    },
    {
      branch: "Americas",
      country: "Colombia",
      companyname: "Ampstek Colombia SAS",
      address: "Cl. 146 #12-72, Usaquén, Bogotá, Colombia",
      phone: "",
      contact: "contact@ampstekpay.com"
    }, 
    {
      branch: "Americas",
      country: "Mexico",
      companyname: "Ampstek Technologies SC",
      address: "Blvd. Diaz Ordaz # 130, Col. Santa Maria Level 10 Monterrey, NL. CP 64650",
      phone: "",
      contact: "contact@ampstekpay.com"
    },
    
    {
      branch: "Americas",
      country: "Argentina",
      companyname: "Ampstek SAS",
      address: "Argentina, Ciudad de Buenos Aires, Ciudad de Buenos Aires Corrientes AV. 222 piso PB 1043 Argentina",
      phone: "",
      contact: "contact@ampstekpay.com"
    }, 
    
    {
        branch: "Middle_East",
        country: "UAE",
        companyname: "Ampstek MEA FZCO",
        address: "Dubai Silicon, Oasis, DDP, Building A2, Unit, 101, Dubai, UAE",
        phone: "",
        contact: "contact@ampstekpay.com"
    },
    {
        branch: "Middle_East",
        country: "Turkey",
        companyname: "Ampstek IT Servis Bilisim Limited Sirketi",
        address: "61/2 Sultan Selim Meh Eski Buykdere Caddesi No 61 2 Kagithane Istanbul",
        phone: "",
        contact: "contact@ampstekpay.com"
    },
    {
        branch: "Middle_East",
        country: "Qatar",
        companyname: "Ampstek Technologies Services",
        address: "Building No 21 Zone 18 Street 977 Doha Qatar",
        phone: "",
        contact: "contact@ampstekpay.com"
    },
    {
      branch: "APAC",
      country: "India",
      location:"Chennai",
      companyname: "Ampstek India Pte Ltd",
      address: "1st Floor, Unit No: 1 & 2, TEK TOWER, No.11, Old Mahabalipuram Road, Okkiyam, Thuraipakkam, Chennai -600 096.",
      phone: "",
      contact: "contact@ampstekpay.com"
    },
    {
      branch: "APAC",
      country: "India",
      location:"Coimbatore",
      companyname: "AmpsTek Pvt Ltd",
      address: "75/771, 1st floor, 7th Street,Tatabad, Coimbatore - 641012.",
      phone: "",
      contact: "contact@ampstekpay.com"
    },
    {
      branch: "APAC",
      country: "India",
      location:"Noida",
      companyname: "Ampstek Solution India Private Limited",
      address: "First Floor, Unit No. 87, Block H, Noida Gautam Buddh Nagar,Noida 201201,Uttar Pradesh UP,India",
      phone: "",
      contact: "contact@ampstekpay.com"
    },
    {
      branch: "APAC",
      country: "Singapore",
      companyname: "Ampstek Singapore Pte Ltd",
      address: "34-00 3 Temasek Avenue Centennial Towers Singapore-039190",
      phone: "65 69160136",
      contact: "contact@ampstekpay.com"
    },
    {
      branch: "APAC",
      country: "Hong Kong",
      companyname: "Ampstek Hong Kong Pte Ltd",
      address: "7-9 Austin Ave, Office Room Number 77, Hong Kong",
      phone: "",
      contact: "contact@ampstekpay.com"
    },
    {
      branch: "APAC",
      country: "Malaysia",
      companyname: "Ampstek Malaysia Sdn Bhd",
      address: "32A Lorong Batu Nilam 13I Bukit Tinggi Klang-41200 Malaysia",
      phone: "",
      contact: "contact@ampstekpay.com"
    },
    {
      branch: "APAC",
      country: "Philippines",
      companyname: "Ampstek Philippines Inc",
      address: "3rd Floor 170 Salcedo Street one salcedo center legaspi Village Metro Manila Makati-1223 Philippines",
      phone: "63 977 461 6676",
      contact: "contact@ampstekpay.com"
    },
    {
      branch: "APAC",
      country: "South Korea",
      companyname: "Ampstek South Korea Co Ltd",
      address: "1374, 369, Gangnam-daero, Seocho-gu, Seoul, Republic of Korea",
      phone: "",
      contact: "contact@ampstekpay.com"
    },
    {
      branch: "APAC",
      country: "Thailand",
      companyname: "Ampstek Thailand Ltd",
      address: "68/47 Y Residence Sukhumvit 113, Moo 3,Soi Dansamrong 42/1, Samrong Nuea Sub-district Mueang Samut Prakan District, Samut Prakan",
      phone: "",
      contact: "contact@ampstekpay.com"
    },
    {
      branch: "APAC",
      country: "Indonesia (West Indo)",
      companyname: "Cv Westindo Indonesia",
      address: "B10 Block B8 Perumahan Gading Kencana Puri Gading Jimbaran Kec Kuta Sel Kabupaten Badung Bali-80361 Indonesia",
      phone: "",
      contact: "contact@ampstekpay.com"
    },
    {
      branch: "APAC",
      country: "SriLanka",
      companyname: "Ampstek Lanka Pvt Ltd",
      address: "No: 57, W. A. Sillva Mawatha, Colombo-06, Postcode: 00600",
      phone: "",
      contact: "contact@ampstekpay.com"
    },
    {
      branch: "APAC",
      country: "Vietnam",
      companyname: "Ampstek Vietnam Co Ltd",
      address: "5F&9F, CJ Building, No 2Bis-4-6 Le Thanh Ton Street Ben Nghe Ward, District 1, Ho Chi Minh City, Vietnam",
      phone: "84 969 999 125",
      contact: "contact@ampstekpay.com"
    },
    {
      branch: "ANZ",
      country: "Australia",
      companyname: "Ampstek Australia Pty Ltd",
      address: "Unit 16/28 Belmont Ave Rivervale, Western Australia. Australia 6103",
      phone: "61 862450617",
      contact: "contact@ampstekpay.com"
    },
    {
      branch: "ANZ",
      country: "New Zealand",
      companyname: "Ampstek New Zealand Ltd",
      address: "257A Queen Street Richmond-7020 New Zealand",
      phone: "64 (9) 8868295",
      contact: "contact@ampstekpay.com"
    },
    {
      branch: "Africas",
      country: "South Africa",
      companyname: "Ampstek South Africa (Pty) Ltd",
      address: "147 Cedar Hills Estate, Fourways, Johannesburg, Gauteng-2512",
      phone: "",
      contact: "contact@ampstekpay.com"
    },
    {
      branch: "Africas",
      country: "Egypt",
      companyname: "Ampstek IT Services",
      address: "Room 3, Apartment 805, 8th floor, Al Maamora Towers, Tower C, 7th district, Nasr City, Cairo",
      phone: "",
      contact: "contact@ampstekpay.com"
    }
  ]
  
  
      
  
  ];
  
  export default CountryAddressData;
  